import React from "react";
import { A, navigate } from "hookrouter";
// import "./Landing.scoped.css";
import styles from "./Landing.module.css";
import { useTranslation } from "react-i18next";
import { BsFillCaretDownFill } from "react-icons/bs";

const Landing = () => {
  return (
    <div className={styles.landing}>
      <Navbar />
      <Hero />
      <ShareStoy />
      <SeeYourStory />
      <ActionLink />
      <HowItWorks />
      <Footer />
    </div>
  );
};

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const dropdownRef = React.useRef();
  const languageDict = {
    en: "English",
    tr: "Türkçe",
  };

  const handleClick = () => {
    dropdownRef.current.classList.add(styles.show);
    window.addEventListener("mouseup", function temp() {
      dropdownRef.current.classList.remove(styles.show);
      window.removeEventListener("mouseup", temp);
    });
  };

  return (
    <div className={styles.navbar}>
      <div
        className={styles.logo}
        style={{
          backgroundImage:
            "url(/yazbie_logo.png)",
        }}
      />
      <div className={styles.right}>
        <A href="/login">
          <h6>Log In/ Sign Up</h6>
        </A>
        <div className={styles.languageListWrapper}>
          <h6 className={styles.languageLabel} onClick={handleClick}>
            {t("landing.nav.language")} <BsFillCaretDownFill />
          </h6>
          <div className={styles.languageList} ref={dropdownRef}>
            {Object.keys(languageDict)
              .filter((lng) => lng !== i18n.language)
              .map((lng) => (
                <h6 onClick={() => i18n.changeLanguage(lng)}>
                  {`${languageDict[lng]} (${t(`language.${lng}`)})`}
                </h6>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const Hero = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.hero}>
      <div className={styles.content}>
        <div className={styles.heading}>{t("landing.hero.heading")}</div>
        <div className={styles.subheading}>{t("landing.hero.subheading")}</div>
        <div className={styles.body}>{t("landing.hero.body")}</div>
        <div className={styles.buttons}>
          <button onClick={() => navigate('/login')}>{t("landing.hero.buttonLeft")}</button>
          <button onClick={() => navigate('/login')}>{t("landing.hero.buttonRight")}</button>
        </div>
      </div>
      <div className={styles.poster}>
        <img alt="hero-devices" src="/epiknovel_macbook.png" />
      </div>
    </div>
  );
};

const ShareStoy = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.shareStory}>
      <div className={styles.heading}>{t("landing.shareStory.heading")}</div>
      <div className={styles.poster}>
        <img alt="reel" src="/epiknovelscreens.jpg" />
      </div>
    </div>
  );
};

const SeeYourStory = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.seeYourStory}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img
            width="190"
            alt="EpikNovels logo"
            src="/yazbie_logo.png"
          />
        </div>
        <div className={styles.heading}>
          {t("landing.seeYourStory.heading")}
        </div>
        <div className={styles.body}>{t("landing.seeYourStory.body")}</div>
      </div>
      <div className={styles.poster}>
        <img width="348" alt="EpikNovel books poster" src="/books.png" />
      </div>
    </div>
  );
};

const ActionLink = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.actionLink}>
      <div onClick={() => navigate('/login')}>{t("landing.actionLink.body")} →</div>
    </div>
  );
};

const HowItWorks = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.howItWorks}>
      <div className={styles.wrapper}>
        <div className={styles.heading}>{t("landing.howItWorks.heading")}</div>
        <div className={styles.subheading}>
          {t("landing.howItWorks.subheading")}
        </div>
        <div className={styles.body}>
          <div className={styles.section}>
            <div className={styles.num}>1</div>
            <div className={styles.sectionContent}>
              <div className={styles.heading}>
                {t("landing.howItWorks.subhead1")}
              </div>
              <div className={styles.body}>{t("landing.howItWorks.body1")}</div>
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.num}>2</div>
            <div className={styles.sectionContent}>
              <div className={styles.heading}>
                {t("landing.howItWorks.subhead2")}
              </div>
              <div className={styles.body}>{t("landing.howItWorks.body2")}</div>
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.num}>3</div>
            <div className={styles.sectionContent}>
              <div className={styles.heading}>
                {t("landing.howItWorks.subhead3")}
              </div>
              <div className={styles.body}>{t("landing.howItWorks.body3")}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div
      className={styles.footer}
      style={{
        background: "url(/epiknovelscreens.jpg) 50% no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className={styles.container}>
        <div className={styles.heading}>{t("landing.portable.heading")}</div>
        <div className={styles.body}>{t("landing.portable.subheading")}</div>
        <div>
          <A href="/login">
            <button>{t("landing.hero.buttonLeft")}</button>
          </A>
          <A href="/login">
            <button>{t("landing.hero.buttonRight")}</button>
          </A>
        </div>
      </div>
    </div>
  );
};
export default Landing;
